/**
 * Trigger a browser file download from a `Blob`. Single source of truth
 * for the import/export sheets and any future "download as XLSX/CSV"
 * surfaces — previously this lived inline in four files and was
 * drifting on the URL-revoke timing.
 *
 * We revoke the object URL on the next tick (after the click has been
 * dispatched and processed). Historically some browsers cancelled the
 * download if the URL was revoked synchronously; modern engines are
 * forgiving but the cost of one `setTimeout(0)` is nil.
 */
export function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Defer revoke so engines that complete the download asynchronously
  // (some Safari versions, browser extensions intercepting `click`)
  // still have a valid object URL when they finish dispatching.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
